import { useMemo } from 'react';

import * as Styled from './event.style';

export const useTimeBasedStyle = (startDate?: string, endDate?: string) =>
  useMemo(() => {
    if (!startDate || !endDate) {
      return {
        marginTop: Styled.maxTopMargin,
        lineHeight: Styled.maxLineHeight,
        numberOfLines: 3,
      };
    }

    const timeDiff =
      new Date(endDate).getTime() - new Date(startDate).getTime();
    const maxTimeDiff = 20 * 60 * 1000; // 15 minutes in milliseconds
    const minutes = timeDiff / 1000 / 60;

    // Determine number of lines based on duration
    const numberOfLines = minutes < 30 ? 1 : minutes < 60 ? 2 : 3;

    return {
      marginTop: Math.min(
        Styled.maxTopMargin,
        (timeDiff / maxTimeDiff) * Styled.maxTopMargin,
      ),
      lineHeight: Math.min(1.5, 1 + (timeDiff / maxTimeDiff) * 0.5),
      numberOfLines,
    };
  }, [endDate, startDate]);
